export default {
  data() {
    return {
      isMobile: false,
      isSmallScreen: false,
      isMobileUserAgent: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    };
  },
  created() {
    this.windowResize();
    window.addEventListener('resize', this.windowResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.windowResize);
  },
  methods: {
    windowResize() {
      // 992 matches Bootstrap's $screen-md breakpoint
      this.isMobile = this.isMobileUserAgent || window.innerWidth < 992;
      this.isSmallScreen = window.innerWidth < 768;
    },
  },
};
